import {connect} from "react-redux";
import Assignment from "./Assignment";
import {bindActionCreators} from "redux";
import {fetchAssignee, changeAssignee, assgineeAccount} from "../../service/Assignment/action";
import {getFilter, getCityByStateId} from "../../service/Account/action";

const mapStateToProps = (state) => ({
    getAssignee:state.AssignmentReducer.getAssignee,
    ChangeAssigneeDetails:state.AssignmentReducer.ChangeAssignee,
    accountAssigneedetails:state.AssignmentReducer.accountAssigneedetails,
    accountFilterContent:state.Dropdown.accountFilterContent,
    geoCity:state.Dropdown.geoCity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchAssignee,
            changeAssignee,
            assgineeAccount,
            getFilter,
            getCityByStateId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Assignment);
